import { getPath } from '@/router/common'
const baseUrl = {
  title: '车辆跟踪',
  path: 'TrackingInTransit'
}

export default [
  {
    path: getPath('OutsourcedGoods', baseUrl),
    name: 'TrackingInTransit_OutsourcedGoods',
    component: () => import(/* webpackChunkName: "TrackingInTransit_OutsourcedGoods" */ '@/views/trackingInTransit/outsourcedGoods/index.vue'),
    meta: {
      title: '车辆跟踪'
    }
  },
  {
    path: getPath('Track', baseUrl),
    name: 'TrackingInTransit_Track',
    component: () => import(/* webpackChunkName: "TrackingInTransit_Track" */ '@/views/trackingInTransit/track/index.vue'),
    meta: {
      title: '跟踪记录'
    }
  },
  {
    path: getPath('TrackContent', baseUrl),
    name: 'TrackingInTransit_TrackContent',
    component: () => import(/* webpackChunkName: "TrackingInTransit_TrackContent" */ '@/views/trackingInTransit/trackContent/index.vue'),
    meta: {
      title: '跟踪内容'
    }
  },
  {
    path: getPath('ImportWaybillTracking', baseUrl),
    name: 'TrackingInTransit_ImportWaybillTracking',
    component: () => import(/* webpackChunkName: "TrackingInTransit_ImportWaybillTracking" */ '@/views/trackingInTransit/importWaybillTracking/index.vue'),
    meta: {
      title: '导入跟踪记录'
    }
  }
]
